export default __webpack_public_path__ + "static/bumble-c32dc9928283e8477a7af7b3f7b9f83a.png";